module.exports = __webpack_public_path__ + "static/media/not_looking_for_work.3dcadb16.svg";